import { ErrorPage } from "Shared/Pages/Error/Error";
import { Outlet } from "react-router-dom";

export const ErrorRoutes = [
	{
		path: "/",
		element: <Outlet />,
		secure: true,
		children: [
			{ path: "/auth/404", element: <ErrorPage /> },
			{ path: "*", element: <ErrorPage /> },
		],
	},
];
